import { Component, ElementRef, EventEmitter, Inject, LOCALE_ID, NgZone, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ColDef, ColumnApi, GridApi, GridOptions } from 'ag-grid-community';
import moment from 'moment';
import { ORDER_ATTACHMENT_TYPE } from '@pos-app/data';
import { BehaviorSubject, Subject } from 'rxjs';
import {
  ApiService,
  AttachmentEntityType,
  CoreUiPartialState,
  getBrandDefaults,
  hasUnsavedChanges,
  MessageService,
  saveCustomerOrderDetailsForTask,
} from '@pos-app/core-ui';
import { CustomersPartialState } from '../../../+state/customers.reducer';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerPOSJobOrderGridActionRenderComponent } from '../../../../orders/components/customerOrderGridActionrRenderer/customerPOSJobOrderGridActionRenderer.component';
import { takeUntil } from 'rxjs/operators';
import { FetchJdeOrder } from '../../../../orders/+state/orders.actions';
import { getUserAssignedCurrencyFormat } from 'libs/core-ui/src/lib/utils/locale-helper';
import { Router } from '@angular/router';
import { GetUserSalesPersonListAction } from '../../../+state/customers.actions';
import { customersQuery } from '../../../+state/customers.selectors';
import { ordersQuery } from '../../../../orders/+state/orders.selectors';

@Component({
  selector: 'app-customers-pos-arb-orders',
  templateUrl: './customers-pos-arb-orders.component.html',
  styleUrls: ['./customers-pos-arb-orders.component.scss'],
})
export class CustomerPosArbOrdersComponent implements OnInit, OnDestroy {
  @ViewChild('content') modalBox: ElementRef;
  @Output() onFetchOrderFromJDE = new EventEmitter();

  gridOptions: GridOptions;
  columnDefs: ColDef[];
  frameworkComponents;
  context;
  rowData = [];
  searchValue: string;
  orderDetails: any;
  isReadOnlyLineAttachment: boolean;
  ORDER_ATTACHMENT_TYPE = ORDER_ATTACHMENT_TYPE;

  private unSubscribe$ = new Subject<void>();
  private gridApi: GridApi;
  private gridColumnApi: ColumnApi;
  public loading$ = new BehaviorSubject<boolean>(false);
  loading: boolean = false;
  currencyCode: any;
  salesPeopleList: any;
  selectedSalesPerson: string;
  formValid: boolean;
  allAttachments: any[];
  entityId: string;
  entityType: AttachmentEntityType;
  defaultCompanyCode: string = JSON.parse(localStorage.getItem('jdeSession')).CompanyCode;
  madeChanges: boolean = false;
  loadingFetchingOrderFromJDE: boolean;
  isShowOrderAttachment: boolean = false;
  isShowSalesPersonSelector: boolean;

  constructor(
    private apiService: ApiService,
    private customerStore: Store<CustomersPartialState>,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private coreUiStore: Store<CoreUiPartialState>,
    private router: Router,
    private ngZone: NgZone,
    private messageService: MessageService,
    @Inject(LOCALE_ID) public locale: string
  ) {
    this.frameworkComponents = {
      actionRenderer: CustomerPOSJobOrderGridActionRenderComponent,
    };
    this.context = { componentParent: this };
    this.gridOptions = this.gridOptionsData();
  }

  ngOnInit(): void {
    this.coreUiStore
      .select(getBrandDefaults)
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((data) => {
        if (data) {
          this.currencyCode = data?.currrencyCode;
          this.fetchOpenArbOrders();
        }
      });

    this.customerStore
      .select(ordersQuery.getIsFetchingJdeOrder)
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((x) =>
        setTimeout(() => {
          this.loadingFetchingOrderFromJDE = x;
        }, 0)
      );
    this.customerStore.dispatch(new GetUserSalesPersonListAction());
  }

  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  // Fetch open ARB job orders
  fetchOpenArbOrders() {
    this.loading = true;
    this.apiService
      .fetchOpenJobRequests()
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe({
        next: (res) => {
          this.loading = false;
          this.rowData = res.orderList;
        },
        error: () => {
          this.loading = false;
        },
        complete: () => {
          this.loading = false;
        },
      });

    if (!!this.rowData) {
      this.gridApi?.setRowData(this.rowData);
    }
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    const sortModel = [{ colId: 'dateTime', sort: 'desc' }];
  }

  gridOptionsData() {
    return {
      defaultColDef: {
        resizable: true,
        sortable: true,
        width: 150,
        cellClass: 'cell-class ag-right-aligned-cell',
        headerClass: 'header-class ag-left-aligned-header',
      },
      columnDefs: [
        {
          headerName: 'ACTION',
          width: 150,
          cellRenderer: 'actionRenderer',
          cellStyle: { 'text-align': 'left' },
        },
        {
          headerName: 'YOUR ORDER NO',
          width: 150,
          field: 'supplierReference',
          cellStyle: { 'text-align': 'left' },
        },
        {
          headerName: 'ORDER STATUS',
          width: 150,
          field: 'orderStatus',
          cellStyle: { 'text-align': 'left' },
        },

        {
          headerName: 'ARB ORDER',
          width: 150,
          field: 'orderNumber',
          cellRenderer: (params) => {
            const link = document.createElement('a');
            link.href = 'javascript:void(0)';
            link.innerText = params.value;
            link.addEventListener('click', () => {
              this.fetchOrderFromJDE(params.data);
            });
            return link;
          },
          cellStyle: { 'text-align': 'left' },
        },
        {
          headerName: 'CUSTOMER REFERENCE',
          width: 180,
          field: 'customerReference',
          cellStyle: { 'text-align': 'left' },
        },
        {
          headerName: 'CUSTOMER NAME',
          width: 200,
          field: 'customer',
          cellStyle: { 'text-align': 'left' },
        },
        {
          headerName: 'PHONE',
          width: 150,
          field: 'customerPhone',
          cellStyle: { 'text-align': 'left' },
        },
        {
          headerName: 'ORDER TYPE',
          width: 140,
          field: 'orderType',
          cellStyle: { 'text-align': 'left' },
        },
        {
          headerName: 'REQUEST DATE',
          width: 160,
          field: 'requestedDate',
          comparator: this.dateComparator,
          cellStyle: { 'text-align': 'left' },
        },
      ],
      onGridReady: (params) => {
        params.columnApi.applyColumnState({
          state: [{ colId: 'requestedDate', sort: 'asc' }],
          applyOrder: true,
        });
      },
    };
  }

  dateComparator(date1: string, date2: string): number {
    const dateParts1 = date1.split('/').map((part) => parseInt(part, 10));
    const dateParts2 = date2.split('/').map((part) => parseInt(part, 10));
    const d1 = new Date(dateParts1[2], dateParts1[1] - 1, dateParts1[0]);
    const d2 = new Date(dateParts2[2], dateParts2[1] - 1, dateParts2[0]);
    return d1.getTime() - d2.getTime();
  }

  dateFormatter(params) {
    return moment(params.value).format('L <HH:mm>');
  }

  attachedItem(cell, isReadOnly) {
    this.entityId = `${cell.orderNumber.toString()}|${cell.orderType}|${this.defaultCompanyCode}`;
    this.entityType = 'order';
    this.orderDetails = cell;
    this.isReadOnlyLineAttachment = isReadOnly;
    this.isShowOrderAttachment = true;
    this.loading = true;
    this.apiService
      .loadAttachmentForOrder({
        orderNumber: cell.orderNumber,
        orderType: cell.orderType,
        JDEOrderType: cell?.JDEOrderType,
        JDECompany: cell?.JDECompany,
      })
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((res: any) => {
        this.loading = false;
        this.allAttachments = res?.attachmentIDArray;
        this.openModalBox();
      });
  }

  downloadFile(item) {
    this.apiService.downloadFile(item._id, item.name).subscribe(() => {});
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  formatTime(time) {
    // JDE time doesn't put a 0 at the start when less than 10am
    if (parseInt(time.slice(0, 2)) > 24) {
      return ['0' + time.slice(0, 1), ':', time.slice(1, 3)].join('');
    } else {
      return [time.slice(0, 2), ':', time.slice(2, 4)].join('');
    }
  }

  fetchOrderFromJDE(data) {
    this.customerStore.dispatch(
      new FetchJdeOrder({
        orderNumber: data.orderNumber,
        orderType: data.orderType,
        JDEOrderType: data?.JDEOrderType,
        JDECompany: data?.JDECompany,
      })
    );
  }

  displayPrice(price: number) {
    if (!price) {
      return '';
    }
    return getUserAssignedCurrencyFormat(price, this.locale, this.currencyCode);
  }

  loadTask(data) {
    this.router.navigate([`central/task-search-order/${data.orderNumber}/${data.orderType}`]);
  }

  changeSalesPerson(cell) {
    this.orderDetails = cell;
    this.customerStore
      .select(customersQuery.getUserSalespersonList)
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((data) => {
        if (data) {
          this.salesPeopleList = data;
          if (this.salesPeopleList?.length > 0) {
            this.isShowSalesPersonSelector = true;
            this.openModalBox();
          } else {
            this.toastr.error('No salesperson list found');
          }
        }
      });
  }

  reloadData() {
    this.fetchOpenArbOrders();
    this.selectedSalesPerson = null;
    this.modalService.dismissAll();
  }

  handleCloseAttachmentModel(event) {
    if (this.isShowOrderAttachment) {
      if (this.madeChanges) {
        this.loading = true;
        this.modalService.dismissAll();
        this.apiService
          .saveAttachmentForOrder({
            orderNumber: this.orderDetails.orderNumber,
            orderType: this.orderDetails.orderType,
            JDEOrderType: this.orderDetails?.JDEOrderType,
            JDECompany: this.orderDetails?.JDECompany,
          })
          .pipe(takeUntil(this.unSubscribe$))
          .subscribe((res: any) => {
            this.loading = false;
            this.allAttachments = res?.attachmentIDArray;
            this.madeChanges = false;
            if (event) {
              this.isShowOrderAttachment = false;
              this.fetchOpenArbOrders();
            }
          });
      } else {
        this.loading = true;
        this.modalService.dismissAll();
        this.apiService
          .unloadAttachmentForOrder({
            orderNumber: this.orderDetails.orderNumber,
            orderType: this.orderDetails.orderType,
          })
          .pipe(takeUntil(this.unSubscribe$))
          .subscribe((res: any) => {
            this.loading = false;
            this.allAttachments = res?.attachmentIDArray;
            if (event) {
              this.isShowOrderAttachment = false;
            }
          });
      }
    }
  }

  addNewTaskForOrder(data) {
    this.orderDetails = data;
    this.coreUiStore.dispatch(saveCustomerOrderDetailsForTask({ customerOrderDetails: { ...data, newTask: true } }));
    this.router.navigate([`central/task/new`]);
  }

  openModalBox() {
    this.modalService
      .open(this.modalBox, {
        windowClass: 'garage-modal',
        size: 'xl',
        backdrop: 'static',
      })
      .result.then(
        (_) => {
          this.isShowOrderAttachment = false;
          this.isShowSalesPersonSelector = false;
        },
        (_) => {
          this.isShowOrderAttachment = false;
          this.isShowSalesPersonSelector = false;
        }
      );
  }

  loadAllAttachments(attachments: any) {
    this.madeChanges = true;
    this.allAttachments = attachments;
  }

  saveTask(objectToUpdate) {
    this.apiService.maintainTask(objectToUpdate).subscribe((res) => {
      if (res?.ErrorFlag === '0') {
        this.toastr.success('Task Updated Successfully');
        this.formValid = false;
        this.coreUiStore.dispatch(hasUnsavedChanges({ unsavedChanges: false }));
        this.messageService.dispatchAction(hasUnsavedChanges({ unsavedChanges: false }));
        this.modalService.dismissAll();
        this.fetchOpenArbOrders();
      }
    });
  }
}
